const API_PREFIX = "/drt/";
const SUPPORT_INTERNAL_PREFIX = "support/internal/";

const trimLeadingSlash = (value: string): string => value.replace(/^\/+/, "");

/**
 * Removes 'support/internal/' prefix from path if present
 * This prevents duplication when the authentication proxy adds it back
 */
const removeSupportInternalPrefix = (path: string): string => {
  const trimmed = trimLeadingSlash(path);
  if (trimmed.startsWith(SUPPORT_INTERNAL_PREFIX)) {
    return trimmed.substring(SUPPORT_INTERNAL_PREFIX.length);
  }
  return trimmed;
};

export const apiRoutes = {
  login: (): string => `${API_PREFIX}api/login`,
  forgotPassword: (): string => `${API_PREFIX}api`,
  session: (): string => `${API_PREFIX}api/session`,
  logout: (): string => `${API_PREFIX}api/logout`,
  feedback: (): string => `${API_PREFIX}api/feedback/send`,
  proxy: (path: string): string => {
    const cleanPath = removeSupportInternalPrefix(path);
    return `${API_PREFIX}api/proxy/${cleanPath}`;
  },
  upload: (path: string): string => {
    const cleanPath = removeSupportInternalPrefix(path);
    return `${API_PREFIX}api/upload/${cleanPath}`;
  },
  download: (path: string): string => {
    const cleanPath = removeSupportInternalPrefix(path);
    return `${API_PREFIX}api/download/${cleanPath}`;
  },
};
